module.exports = __webpack_public_path__ + "img/editors.7603e401.svg";